import { useQuery } from "@apollo/client/react";

import { inbox } from "./inbox.graphql";
import { inboxQueryVariables, type InboxQueryVariables } from "./query";

type WaitingQuery = {
  inbox?: { total?: number | null } | null;
};

/** Sidebar / header badge. Same document as the list. `limit: 0` omits items. `null` until the query has data. */
export const useInboxWaitingCount = (enabled: boolean): number | null => {
  const { data } = useQuery<WaitingQuery, InboxQueryVariables>(inbox, {
    skip: !enabled,
    variables: inboxQueryVariables({
      category: "EVERYTHING",
      limit: 0,
    }),
  });
  if (data?.inbox == null) {
    return null;
  }
  return data.inbox.total ?? 0;
};
